import Swal from 'sweetalert2'
import { axiosInstance } from '@/plugins/axios'

export class BusCaptainService {
  /**
  * @param {AxiosInstance} axios
  * */
  constructor (axios) {
    this.axios = axios
  }

  removeAsBusCaptain (id, swal, userName, { successFxn, errorFxn }, promptMessage = null) {
    swal({
      icon: 'question',
      title: 'Please Confirm',
      text: promptMessage || `Are you sure you want to remove ${userName} as bus captain?`,
      showConfirmButton: true,
      showCancelButton: true,
      preConfirm: () => {
        return this.axios
          .delete(`/v1/bus-captains/${id}`)
          .catch((error) => {
            const msg =
              error.response && error.response.data
                ? error.response.data.message
                : 'An error occurred, please try again.'
            swal().showValidationMessage(msg)
            errorFxn.call(this, error)
          })
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        successFxn.call(this)
        swal({
          icon: 'success',
          title: 'Success',
          text: 'Action successful!',
          showCloseButton: true
        })
      }
    })
  }

  /**
   * @param {Number,String} payload.user_id,
   * @param {Number,String} payload.route_itinerary_id,
  * */
  addAsBusCaptain (payload) {
    return this.axios.post('/v1/bus-captains', payload)
  }

  fetchAllBusCaptains (page, size, query) {
    const params = {
      page: page,
      limit: size,
      search: query,
      related: 'user,route,itinerary'
    }
    return this.axios.get('/v1/bus-captains', { params })
  }
}

const busCaptainService = new BusCaptainService(axiosInstance)

export default busCaptainService
